import CurrentWeather from "./CurrentWeather"

export default CurrentWeather
